if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/*
function renderThreeMSB_Subscription(rc_custom_widget) {
  var subscription_bar_content = document.querySelector(".subscription_bar_content");
  var subscription_bar_price = document.querySelector(".subscription_bar_price");
  var subscription_bar_billed = document.querySelector(".subscription_bar_billed");
  var subscription_bar_discount = document.querySelector(".subscription_discount");

  var subsaveSubscriptionText = rc_custom_widget.querySelector("[data-label-text-three_msb]").innerText;
  var subsavePrice = rc_custom_widget.querySelector("[data-price-three_msb]").innerText;
  var msb_billed = rc_custom_widget.querySelector(".rc_three_msb_billed").innerText;
  var subsaveDiscount = rc_custom_widget.querySelector(".rc_three_msb_discount").innerText;

  rc_custom_widget.classList.remove("hidden");
  var rc_widget = document.querySelector(
    ".rc-container-wrapper[data-widget-container-wrapper] .rc-radio-group__options"
  );
  if (rc_widget) {
    var rc_append_target = rc_widget.lastElementChild;
    rc_widget.insertBefore(rc_custom_widget, rc_append_target);
  }
  rc_custom_widget.addEventListener("click", (event) => {
    var active_option = document.querySelector(".rc_widget__option--active");
    if (active_option) {
      active_option.classList.remove("rc-option--active");
      active_option.classList.remove("rc_widget__option--active");
      var active_option_radio = document.querySelector(".rc_widget__option__input:checked");
      active_option_radio.checked = false;
      rc_custom_widget.querySelector(".option__three_msb").classList.add("active");

      var custom_rc_option_price = document.querySelector(".rc_three_msb_price").innerHTML;
      var recharge_inner_most_price = document.querySelector(".price__regular");
      recharge_inner_most_price.innerHTML = custom_rc_option_price;

      var selling_plan = rc_custom_widget.dataset.sellingplan;
      document.querySelector('input[name="selling_plan"]').value = selling_plan;

      var variant_id = rc_custom_widget.dataset.variant_id;
      document.querySelector(".product-variant-id").value = variant_id;
    }

    subscription_bar_content.innerText = subsaveSubscriptionText;
    subscription_bar_price.innerText = subsavePrice;
    subscription_bar_billed.innerText = msb_billed;
    subscription_bar_discount.innerText = subsaveDiscount;
  });
}

// recharge prices seem to be fixed in Sterling no matter what the presentment currency is
// recharge support refuses to fix it, so some disgraceful hackery is needed...
function ActiveCurrencyString(val) {
  var locale = "en-GB";
  if (Shopify.currency.active == "USD") {
    locale = "en-US";
  }
  return new Intl.NumberFormat(locale, { style: "currency", currency: Shopify.currency.active }).format(val);
}
function ShowCorrectCurrencyOnOneRechargeElement(selector) {
  var element = document.querySelector(selector);
  if (element && element.getAttribute("data-lightning-rc_fix") == undefined) {
    var text = element.textContent;
    var val = Number(text.substr(1));
    val = val * Shopify.currency.rate;

    element.setAttribute("data-lightning-rc_fix", text);
    element.innerHTML = ActiveCurrencyString(val);
  }
}
function FixRechargeCurrencyDisplay() {
  ShowCorrectCurrencyOnOneRechargeElement(".rc_widget__price--subsave");
  ShowCorrectCurrencyOnOneRechargeElement(".rc_widget__price--onetime");
}

function renderRCcontent(wrapper) {
  var sub_save = wrapper.querySelector(".rc-option__discount").innerHTML;
  var save_discount_element = wrapper.querySelector(".rc_widget__option--subsave");
  var save_price_element = wrapper.querySelector(".rc_widget__option--subsave .rc_widget__option__label");
  var Discelement = document.createElement("span");

  var DisElcontent = document.createTextNode("Save " + sub_save);
  Discelement.className = "save-discount";
  Discelement.appendChild(DisElcontent);
  save_discount_element.appendChild(Discelement);

  setTimeout(() => {
    FixRechargeCurrencyDisplay();

    var sub_save_price = wrapper.querySelector(".rc_widget__price--subsave").innerHTML;
    var BillElcontent = document.createTextNode(sub_save_price + " billed monthly");
    var Billelement = document.createElement("span");

    Billelement.className = "subsave-billed";
    Billelement.appendChild(BillElcontent);
    save_price_element.appendChild(Billelement);
    var deliveryText = document.createTextNode("1 month supply delivered monthly");
    var deliveryElement = document.createElement("span");
    deliveryElement.className = "monthly-delivery";
    deliveryElement.appendChild(deliveryText);
    save_price_element.appendChild(deliveryElement);
  }, 70);
}

function renderStickyContentText(wrapper, subscription_bar_content) {
  var subscription_bar_price = document.querySelector(".subscription_bar_price");
  var subscription_bar_billed = document.querySelector(".subscription_bar_billed");
  var subscription_bar_discount = document.querySelector(".subscription_discount");

  // onetime Subscription
  var onetimeSubscriptionText = wrapper.querySelector("[data-label-text-onetime]").innerText;
  var onetimePrice = wrapper.querySelector("[data-price-onetime]").innerText;

  // subsave Subscription
  var subsaveSubscriptionText = wrapper.querySelector("[data-label-text-subsave]").innerText;
  var subsavePrice = wrapper.querySelector("[data-price-subsave]").innerText;
  var subsaveDiscount = wrapper.querySelector(".rc-option__subsave [data-label-discount]").innerText;

  var checkedValue = wrapper.querySelector(".rc_widget__option--active [type='radio']").value;

  if (checkedValue == "subsave") {
    subscription_bar_content.innerText = subsaveSubscriptionText;
    subscription_bar_price.innerText = subsavePrice;
    subscription_bar_billed.innerText = subsavePrice + " billed monthly";
    subscription_bar_discount.innerText = "save " + subsaveDiscount;
  } else if (checkedValue === "onetime") {
    subscription_bar_content.innerText = onetimeSubscriptionText;
    subscription_bar_price.innerText = onetimePrice;
    subscription_bar_billed.innerText = "";
    subscription_bar_discount.innerText = "";
  }
}

function renderFooterBarContent(wrapper) {
  var subscription_bar_content = document.querySelector(".subscription_bar_content");
  var rc_custom_option__three_msb = document.querySelector(".rc-custom-option__three_msb");

  if (subscription_bar_content) {
    setTimeout(() => {
      // put value in dom load
      renderStickyContentText(wrapper, subscription_bar_content);

      // put value in input change
      var radioInputs = wrapper.querySelectorAll(".rc-radio__input[type='radio']");
      radioInputs.forEach((radioInput) => {
        radioInput.addEventListener("change", (event) => {
          renderStickyContentText(wrapper, subscription_bar_content);
          rc_custom_option__three_msb.classList.remove("active");

          var selected_rc_option_price = radioInput.nextSibling.querySelector(".rc-option__price").innerHTML;
          var recharge_inner_most_price = document.querySelector(".price__regular");
          recharge_inner_most_price.innerHTML = selected_rc_option_price;

          var rc_custom_widget = document.querySelector(".rc-custom-widget");
          var variant_id = rc_custom_widget.dataset.default_product_variant_id;
          document.querySelector(".product-variant-id").value = variant_id;

          var selected_option_selling_plan = document.querySelector('select[name="selling_plan"]').value;
          if (selected_option_selling_plan) {
            document.querySelector('input[name="selling_plan"]').value = selected_option_selling_plan;
          } else {
            document.querySelector('input[name="selling_plan"]').value = "";
          }
        });
      });
    }, 80);
  }
}

function InitialiseProductPageJSLoad(e) {
  var rc_custom_widget = document.querySelector(".rc-custom-widget");
  var watch = document.querySelector(".product__info-container");
  var observer = new MutationObserver(function (ml, o) {
    var wrapper = watch.querySelector("[data-widget-container-wrapper]");

    if (wrapper) {
      console.log("Recharge widget loaded");
      renderThreeMSB_Subscription(rc_custom_widget);
      renderRCcontent(wrapper);
      renderFooterBarContent(wrapper);
      ScrollToSubscriptionDetails(wrapper);
      observer.disconnect();
    }
  });
  observer.observe(watch, { "childList": true, "subtree": true });

  if (watch) {
    observer.observe(watch, { "childList": true, "subtree": true });
  }
}
*/

function ScrollStickyAddtoCart() {
  var defaultButton = document.querySelector(".main_addTo_cart");
  var SubscriptionAddtocartBtn = document.querySelector(".subscription_sticky_addtocart");
  SubscriptionAddtocartBtn.addEventListener("click", (event) => {
    defaultButton.click();
  });

  var defaultButton = document.querySelector(".main_addTo_cart");
  var stickyButtonBar = document.querySelector(".footer-buy-button-bar");

  // Show/hide the sticky BAR based on scroll position
  window.addEventListener("scroll", function () {
    if (!isElementVisible(defaultButton)) {
      stickyButtonBar.style.display = "block";
    } else {
      stickyButtonBar.style.display = "none";
    }
  });
}

// Function to check if an element is visible on the screen
function isElementVisible(defaultButton) {
  var defaultButtonEL = defaultButton.getBoundingClientRect();
  return (
    defaultButtonEL.top >= 0 &&
    defaultButtonEL.left >= 0 &&
    defaultButtonEL.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    defaultButtonEL.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/*
function ScrollToSubscriptionDetails(wrapper) {
  // Scroll TO subscription(Sbc_) details
  var StickySbc_details_buttons = document.querySelectorAll(".subscription_details_btn");
  var mainSbc_details = wrapper;

  StickySbc_details_buttons.forEach((StickySbc_details_button) => {
    StickySbc_details_button.addEventListener("click", function () {
      mainSbc_details.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    });
  });
}
*/

window.addEventListener("load", function (e) {
  //InitialiseProductPageJSLoad(e);
  ScrollStickyAddtoCart(e);
});

// Skio implementation for updating the sticky cart
document.addEventListener("skio::update-selling-plan", (e) => {
  var subscription_bar_content = document.querySelector(".subscription_bar_content");
  var subscription_bar_price = document.querySelector(".subscription_bar_price");
  var subscription_bar_billed = document.querySelector(".subscription_bar_billed");
  var subscription_bar_discount = document.querySelector(".subscription_discount");

  var skioWrapper = document.querySelector("skio-plan-picker").shadowRoot.querySelector(".skio-plan-picker");

  subscription_bar_content.innerText = skioWrapper.querySelector(
    ".group-container--selected .membership-frequency"
  ).innerText;
  subscription_bar_price.innerText = skioWrapper.querySelector(".group-container--selected .skio-price").innerText;

  if (e.detail.sellingPlan) {
    subscription_bar_billed.style.display = "block";
    subscription_bar_discount.style.display = "block";

    subscription_bar_billed.innerText = skioWrapper.querySelector(
      ".group-container--selected .price-x-frequency"
    ).innerText;

    subscription_bar_discount.innerText = skioWrapper.querySelector(
      ".group-container--selected .savings.bubble"
    ).innerText;
  } else {
    subscription_bar_billed.style.display = "none";
    subscription_bar_discount.style.display = "none";
  }
});
